import EventEmitter from 'eventemitter3'
import i18n from '../../i18n/i18nConfig'
import {getAdvanceColumns} from '../authentication/AuthUtils'
import PageContentWrapper from '../layout/PageContentWrapper'
export const tableEvent = new EventEmitter()
export const dataListEvent = new EventEmitter()
export const refetchEvent = new EventEmitter()
//#region used for custom table

// Reload datatable with new or updating data
export function reloadDataTable(queryKey = '', data) {
    if (!!queryKey) {
        tableEvent.emit('RELOAD-DATA-TABLE-' + queryKey, data)
    }
}

export function removeReloadDataTable(queryKey = '') {
    tableEvent.removeListener('RELOAD-DATA-TABLE-' + queryKey)
}

// Fully reload datatable
export function refetchCurrentData(queryKey = '') {
    if (!!queryKey) {
        refetchEvent.emit('REFETCH-DATA-TABLE-' + queryKey)
    }
}

//#endregion

//#region used for option list
export function reloadDataList(component, data) {
    dataListEvent.emit('RELOAD-DATA-LIST-' + component, data)
}
//#endregion

export function convertKeyToLabel(key) {
    if (!key) {
        return ''
    }

    try {
        return i18n.t(
            key
                .replace(/(_|-)/g, ' ')
                .trim()
                .replace(/\w\S*/g, function (str) {
                    return str.charAt(0).toUpperCase() + str.substr(1)
                })
                .replace(/([a-z])([A-Z])/g, '$1 $2')
                .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2'),
            ['key.js'],
        )
    } catch (error) {
        return key
    }
}

export function convertLabelToEnum(key) {
    if (!key) {
        return ''
    }

    return key
        .replace(/(_|-)/g, '')
        .trim()
        .replace(/\w\S*/g, function (str) {
            return str.charAt(0).toUpperCase() + str.substr(1)
        })
        .replace(/ /g, function (article) {
            return article.split(' ').join('')
        })
        .replace(/([/])/g, '')
        .replace(/([:])/g, '')
        .replace(/([;])/g, '')
        .replace(/([&])/g, '')
        .replace(/([,])/g, '')
        .replace(/([+])/g, '')
        .replace(/([.])/g, '')
        .replace(/([()])/g, '')
        .replace(/([a-z])([A-Z])/g, '$1$2')
        .replace(/([A-Z])([A-Z][a-z])/g, '$1$2')
        .replace(/\w\S*/g, function (str) {
            return str.charAt(0).toLowerCase() + str.substr(1)
        })
}

export const convertArrayStringToOptionsList = arrOptionsList => {
    return (
        <PageContentWrapper>
            {arrOptionsList.map((item, idx) => (
                <div key={idx}>
                    <span>{convertLabelToEnum(item.toLowerCase())}</span>{' '}
                    <span>( "{item}"),</span>
                </div>
            ))}

            <div>
                {' '}
                <div>private String value; </div>
                <div>
                    {' '}
                    public String getValue(){' '}
                    {` {
return value;
}`}{' '}
                </div>
                <div>
                    {`private AddressType(String value) {
this.value = value;
}`}{' '}
                </div>
            </div>
            <div>-------------------</div>
            <div>{`export const titleList = [ `}</div>
            {arrOptionsList.map((item, idx) => (
                <div key={idx}>
                    <span>
                        {`{ label: '${item}
                ' , value: '${convertLabelToEnum(item.toLowerCase())} '},`}{' '}
                    </span>{' '}
                </div>
            ))}
            <div>{`]`}</div>
        </PageContentWrapper>
    )
}

export const getAdvanceColumnsStorage = type => {
    const advanceColumnsStorageString = getAdvanceColumns()

    if (
        !type ||
        !advanceColumnsStorageString ||
        advanceColumnsStorageString?.length < 1
    ) {
        return []
    }

    let advanceColumnsStorage = JSON.parse(advanceColumnsStorageString)

    return !!advanceColumnsStorage && !!advanceColumnsStorage[type]
        ? advanceColumnsStorage[type]
        : {}
}
